import React from 'react'
import { Colors } from '../../../theme'

const IconCalculator = (props) => {
  const color = props.altcolor === true ? Colors.Palette.whiteColor : Colors.Palette.primaryColor
  // <?xml version="1.0" encoding="UTF-8"?>
  return (
    <svg width="28px" height="40px" viewBox="0 0 28 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      {/* <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch --> */}
      <title>calculator_24px</title>
      <desc>Created with Sketch.</desc>
      <g id="🖥-WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="PENSION" transform="translate(-311.000000, -828.000000)" fillRule="nonzero">
          <g id="Pension-Calculator" transform="translate(272.000000, 739.000000)">
            <g id="calculator_24px" transform="translate(29.000000, 85.000000)">
              <rect id="Rectangle-3" x="0" y="0" width="48" height="48"></rect>
              <path d="M14,4 L34,4 C36.209139,4 38,5.790861 38,8 L38,40 C38,42.209139 36.209139,44 34,44 L14,44 C11.790861,44 10,42.209139 10,40 L10,8 C10,5.790861 11.790861,4 14,4 Z M14,8 L14,16 L34,16 L34,8 L14,8 Z M14,20 L14,24 L18,24 L18,20 L14,20 Z M22,20 L22,24 L26,24 L26,20 L22,20 Z M30,20 L30,24 L34,24 L34,20 L30,20 Z M14,28 L14,32 L18,32 L18,28 L14,28 Z M22,28 L22,32 L26,32 L26,28 L22,28 Z M30,28 L30,32 L34,32 L34,28 L30,28 Z M14,36 L14,40 L18,40 L18,36 L14,36 Z M22,36 L22,40 L26,40 L26,36 L22,36 Z M30,36 L30,40 L34,40 L34,36 L30,36 Z" id="Shape" fill={`${color}`}></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconCalculator



// WEBPACK FOOTER //
// ./src/assets/images/svg/Icon-Calculator.js